// src/ui/design-system/spacing.ts

export const space = {
  xs: "4px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  xl: "40px",
  xxl: "64px",
} as const;

export const radius = {
  sm: "8px",
  md: "14px",
  lg: "22px",
  full: "999px",
} as const;

/** 2.3節: 44px以上のタップ領域を全インタラクティブ要素で確保する */
export const minTapTarget = "44px";
